import { FC, ReactElement } from 'react'

import { Page, SidebarPageWrapper } from '../../components'
import { Sidebar } from '../../compositions'
import { ConnectedValkTalkPostsFilter } from '../../connectors/@filters/ConnectedValkTalkPostsFilter/ConnectedValkTalkPostsFilter'
import { ConnectedValkTalkPosts } from '../../connectors/ConnectedValkTalkPosts/ConnectedValkTalkPosts'

export const ValkTalkPostsPage: FC = (): ReactElement => (
    <SidebarPageWrapper>
        <Sidebar showSidebarToggle>
            <ConnectedValkTalkPostsFilter />
        </Sidebar>
        <Page>
            <ConnectedValkTalkPosts />
        </Page>
    </SidebarPageWrapper>
)
